




































































































import Vue from "vue";
import { mapGetters } from "vuex";
import semver from "semver";

// Components
import InstallationPropsList from "@/components/PropsLists/InstallationPropsList.vue";
import InstallationTreePath from "@/components/InstallationTreePath.vue";
import AgentInfoPropsList from "@/components/PropsLists/AgentInfoPropsList.vue";
import ForceCheckDialogCard from "@/views/App/ServiceAndUpdates/UpdatesManagement/ForceCheckDialogCard.vue";

// Model
import { Installation } from "@/model/data/Installation";
import { getImageFromModel_200 } from "@/utility/Constants";
import { SendCaosRebootReqData, SendCaosRebootCommand } from "@/model/communication/device/SendCaosRebootCommand";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { InstallationUpdate } from "@/model/data/updates/InstallationUpdate";

export default Vue.extend({
    components: {
        InstallationPropsList,
        InstallationTreePath,
        AgentInfoPropsList,
        ForceCheckDialogCard,
    },
    props: {
        installation: { type: Object as () => Installation, required: true },
        showAgentInfo: Boolean,
        caosBackendAddress: Array,
    },
    data() {
        return {
            ClientPrivileges,
            rebootIcon: "fas fa-redo-alt",
            showRebootDialog: false,
            rebootLoading: false,
            rebootError: false,
            rebootErrorMessage: "",
            alertType: "",
            showForceCheckDialog: false,
            openTunnelIcon: "fas fa-link",
            openTunnelLoading: false,
            closeTunnelIcon: "fas fa-unlink",
            closeTunnelLoading: false,
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        installationIsUpToDate() {
            try {
                if (this.installation == null || this.installation == undefined || this.installation.constructor.name != InstallationUpdate.name) return true;
                return this.installation.isUpToDate();
            } catch {
                return true;
            }
        },
        hasAgent() {
            try {
                if (this.installation && this.installation.agentInfo && this.installation.agentInfo.version) {
                    let splittedVersion = this.installation.agentInfo.version.split(".");
                    if (splittedVersion && splittedVersion.length >= 3) return semver.gte(`${splittedVersion[0]}.${splittedVersion[1]}.${splittedVersion[2]}`, "7.1.0");
                }
            } catch {
                console.error("Cannot parse agent version");
            }
            return false;
        },
    },
    methods: {
        getImageFromModel_200,
        async sendReboot() {
            try {
                this.rebootLoading = true;
                this.rebootIcon = "fa-solid fa-circle-notch fa-spin";
                let reqData = new SendCaosRebootReqData(this.installation.name);
                let response: ApiGenericResponse = await new SendCaosRebootCommand(reqData).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString.toLowerCase() == "success") {
                    this.rebootIcon = "fas fa-check";
                } else {
                    throw response.message;
                }
            } catch (error) {
                switch (error) {
                    case CReqExecutionResultEnum.AgentOffline:
                        this.rebootErrorMessage = this.$t("device_status.agentOfflineForInstallation", { task: "reboot" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.AgentNotInstalled:
                        this.rebootErrorMessage = this.$t("device_status.agentNotInstalled", { task: "reboot" });
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.DeviceLocked:
                        this.rebootErrorMessage = this.$t("device_status.agentLocked", { task: "reboot" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.rebootErrorMessage = this.$t("device_status.operationNotAvailable", { task: "reboot" });
                        this.alertType = "info";
                        break;
                    case CReqExecutionResultEnum.ServerError:
                        this.rebootErrorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.InvalidRequest:
                        this.rebootErrorMessage = this.$t("device_status.invalidVersion", { task: "reboot" });
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending MachineReboot request ", error);
                        this.rebootErrorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                }
                this.rebootIcon = "fas fa-redo-alt";
                this.rebootError = true;
            }
            this.rebootLoading = false;
        },
        openCaosBackend() {
            if (this.caosBackendAddress && this.caosBackendAddress.length && this.caosBackendAddress.length > 1) window.open(this.caosBackendAddress[1], "_blank");
        },
    },
});
